var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.333,
    height: 34.989,
    viewBox: "0 0 27.333 34.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M18.666,1.5a8.757,8.757,0,0,0-8.746,8.746v5.47H8.827A3.831,3.831,0,0,0,5,19.541v13.12a3.831,3.831,0,0,0,3.827,3.827H28.506a3.831,3.831,0,0,0,3.827-3.827V19.541a3.831,3.831,0,0,0-3.827-3.827H27.412v-5.47A8.757,8.757,0,0,0,18.666,1.5ZM13.2,10.245a5.467,5.467,0,0,1,10.933,0v5.47H13.2Zm-.546,17.507a1.64,1.64,0,1,1,1.64-1.64A1.638,1.638,0,0,1,12.653,27.752Zm6.013,0a1.64,1.64,0,1,1,1.64-1.64A1.638,1.638,0,0,1,18.666,27.752Zm6.013,0a1.64,1.64,0,1,1,1.64-1.64A1.638,1.638,0,0,1,24.679,27.752Z",
    transform: "translate(-5 -1.498)",
    fill: "#df9426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.c49100fc1d971462347b47a85348331c.svg";
export { ForwardRef as ReactComponent };